import type { Job } from "@eai-toolkit/client";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import { actions as apiActions } from "../api/actions";

export type JobsState = Job[] | null;

const INITIAL_STATE: JobsState = null;

export function jobs(
  state: JobsState = INITIAL_STATE,
  action: ActionType<typeof apiActions>,
): JobsState {
  switch (action.type) {
    case getType(apiActions.getJobs.success): {
      return action.payload;
    }
    case getType(apiActions.retryJob.success): {
      const restartedJob = action.payload;

      const newState = [...(state ?? [])];

      const jobIndex = newState.findIndex((j) => j.id === restartedJob.id);
      newState[jobIndex] = restartedJob;

      return newState;
    }
    default:
      return state;
  }
}
